import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import r from "../request.js";
import t from "../TimeExtent.js";
import o from "../core/Error.js";
import { HandleOwnerMixin as i } from "../core/HandleOwner.js";
import { loadAll as s } from "../core/loadAll.js";
import { isSome as a } from "../core/maybe.js";
import { MultiOriginJSONMixin as p } from "../core/MultiOriginJSONSupport.js";
import { throwIfAbortError as n, isAbortError as m } from "../core/promiseUtils.js";
import { property as l } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { Integer as c } from "../core/accessorSupport/ensureType.js";
import { reader as u } from "../core/accessorSupport/decorators/reader.js";
import { subclass as y } from "../core/accessorSupport/decorators/subclass.js";
import { writer as d } from "../core/accessorSupport/decorators/writer.js";
import { nameToId as h } from "../core/accessorSupport/PropertyOrigin.js";
import f from "../geometry/Extent.js";
import { getScale as g } from "../geometry/support/scaleUtils.js";
import x from "./Layer.js";
import { APIKeyMixin as b } from "./mixins/APIKeyMixin.js";
import { ArcGISMapService as j } from "./mixins/ArcGISMapService.js";
import { ArcGISService as v } from "./mixins/ArcGISService.js";
import { BlendLayer as S } from "./mixins/BlendLayer.js";
import { CustomParametersMixin as w } from "./mixins/CustomParametersMixin.js";
import { OperationalLayer as O } from "./mixins/OperationalLayer.js";
import { PortalLayer as I } from "./mixins/PortalLayer.js";
import { RefreshableLayer as L } from "./mixins/RefreshableLayer.js";
import { ScaleRangeLayer as P } from "./mixins/ScaleRangeLayer.js";
import { SublayersOwner as M } from "./mixins/SublayersOwner.js";
import { TemporalLayer as E } from "./mixins/TemporalLayer.js";
import { url as U } from "./support/commonProperties.js";
import { ExportImageParameters as N } from "./support/ExportImageParameters.js";
import T from "./support/Sublayer.js";
import { shouldWriteSublayerStructure as J } from "./support/sublayerUtils.js";

var q = /*#__PURE__*/function (_S) {
  _inherits(q, _S);

  var _super = _createSuper(q);

  function q() {
    var _this;

    _classCallCheck(this, q);

    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(e)), _this.datesInUnknownTimezone = !1, _this.dpi = 96, _this.gdbVersion = null, _this.imageFormat = "png24", _this.imageMaxHeight = 2048, _this.imageMaxWidth = 2048, _this.imageTransparency = !0, _this.isReference = null, _this.labelsVisible = !1, _this.operationalLayerType = "ArcGISMapServiceLayer", _this.sourceJSON = null, _this.sublayers = null, _this.type = "map-image", _this.url = null;
    return _this;
  }

  _createClass(q, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(e, r) {
      return "string" == typeof e ? _objectSpread({
        url: e
      }, r) : e;
    }
  }, {
    key: "load",
    value: function load(e) {
      var _this2 = this;

      var r = a(e) ? e.signal : null;
      return this.addResolvingPromise(this.loadFromPortal({
        supportedTypes: ["Map Service"]
      }, e).catch(n).then(function () {
        return _this2._fetchService(r);
      })), Promise.resolve(this);
    }
  }, {
    key: "readImageFormat",
    value: function readImageFormat(e, r) {
      var t = r.supportedImageFormatTypes;
      return t && t.indexOf("PNG32") > -1 ? "png32" : "png24";
    }
  }, {
    key: "writeSublayers",
    value: function writeSublayers(e, r, t, o) {
      if (!this.loaded || !e) return;
      var i = e.slice().reverse().flatten(function (_ref) {
        var e = _ref.sublayers;
        return e && e.toArray().reverse();
      }).toArray();
      var s = !1;

      if (this.capabilities && this.capabilities.operations.supportsExportMap && this.capabilities.exportMap.supportsDynamicLayers) {
        var _e = h(o.origin);

        if (3 === _e) {
          var _e2 = this.createSublayersForOrigin("service").sublayers;
          s = J(i, _e2, 2);
        } else if (_e > 3) {
          var _e3 = this.createSublayersForOrigin("portal-item");

          s = J(i, _e3.sublayers, h(_e3.origin));
        }
      }

      var a = [],
          p = _objectSpread({
        writeSublayerStructure: s
      }, o);

      var n = s;
      i.forEach(function (e) {
        var r = e.write({}, p);
        a.push(r), n = n || "user" === e.originOf("visible");
      });
      a.some(function (e) {
        return Object.keys(e).length > 1;
      }) && (r.layers = a), n && (r.visibleLayers = i.filter(function (e) {
        return e.visible;
      }).map(function (e) {
        return e.id;
      }));
    }
  }, {
    key: "createExportImageParameters",
    value: function createExportImageParameters(e, r, t, o) {
      var i = o && o.pixelRatio || 1;
      e && this.version >= 10 && (e = e.clone().shiftCentralMeridian());
      var s = new N({
        layer: this,
        floors: null == o ? void 0 : o.floors,
        scale: g({
          extent: e,
          width: r
        }) * i
      }),
          a = s.toJSON();
      s.destroy();
      var p = !o || !o.rotation || this.version < 10.3 ? {} : {
        rotation: -o.rotation
      },
          n = e && e.spatialReference,
          m = n.wkid || JSON.stringify(n.toJSON());
      a.dpi *= i;
      var l = {};

      if (null != o && o.timeExtent) {
        var _o$timeExtent$toJSON = o.timeExtent.toJSON(),
            _e4 = _o$timeExtent$toJSON.start,
            _r = _o$timeExtent$toJSON.end;

        l.time = _e4 && _r && _e4 === _r ? "" + _e4 : "".concat(null == _e4 ? "null" : _e4, ",").concat(null == _r ? "null" : _r);
      } else this.timeInfo && !this.timeInfo.hasLiveData && (l.time = "null,null");

      return _objectSpread(_objectSpread(_objectSpread({
        bbox: e && e.xmin + "," + e.ymin + "," + e.xmax + "," + e.ymax,
        bboxSR: m,
        imageSR: m,
        size: r + "," + t
      }, a), p), l);
    }
  }, {
    key: "fetchImage",
    value: function () {
      var _fetchImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t, i, s) {
        var a, p, n;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                p = {
                  responseType: "image",
                  signal: null != (a = null == s ? void 0 : s.signal) ? a : null,
                  query: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.parsedUrl.query), this.createExportImageParameters(e, t, i, s)), {}, {
                    f: "image"
                  }, this.refreshParameters), this.customParameters), {}, {
                    token: this.apiKey
                  })
                }, n = this.parsedUrl.path + "/export";

                if (!(null != p.query.dynamicLayers && !this.capabilities.exportMap.supportsDynamicLayers)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Promise.reject(new o("mapimagelayer:dynamiclayer-not-supported", "service ".concat(this.url, " doesn't support dynamic layers, which is required to be able to change the sublayer's order, rendering, labeling or source."), {
                  query: p.query
                })));

              case 3:
                return _context.abrupt("return", r(n, p).then(function (e) {
                  return e.data;
                }).catch(function (e) {
                  if (m(e)) throw e;
                  throw new o("mapimagelayer:image-fetch-error", "Unable to load image: ".concat(n), {
                    error: e
                  });
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchImage(_x, _x2, _x3, _x4) {
        return _fetchImage.apply(this, arguments);
      }

      return fetchImage;
    }()
  }, {
    key: "fetchRecomputedExtents",
    value: function () {
      var _fetchRecomputedExtents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var e,
            o,
            _yield$r,
            i,
            s,
            a,
            p,
            n,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                o = _objectSpread(_objectSpread({}, e), {}, {
                  query: _objectSpread(_objectSpread({
                    returnUpdates: !0,
                    f: "json"
                  }, this.customParameters), {}, {
                    token: this.apiKey
                  })
                });
                _context2.next = 4;
                return r(this.url, o);

              case 4:
                _yield$r = _context2.sent;
                i = _yield$r.data;
                s = i.extent;
                a = i.fullExtent;
                p = i.timeExtent;
                n = s || a;
                return _context2.abrupt("return", {
                  fullExtent: n && f.fromJSON(n),
                  timeExtent: p && t.fromJSON({
                    start: p[0],
                    end: p[1]
                  })
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchRecomputedExtents() {
        return _fetchRecomputedExtents.apply(this, arguments);
      }

      return fetchRecomputedExtents;
    }()
  }, {
    key: "loadAll",
    value: function loadAll() {
      var _this3 = this;

      return s(this, function (e) {
        e(_this3.allSublayers);
      });
    }
  }, {
    key: "_fetchService",
    value: function () {
      var _fetchService2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        var _yield$r2, t, o;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.sourceJSON) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", void this.read(this.sourceJSON, {
                  origin: "service",
                  url: this.parsedUrl
                }));

              case 2:
                _context3.next = 4;
                return r(this.parsedUrl.path, {
                  query: _objectSpread(_objectSpread(_objectSpread({
                    f: "json"
                  }, this.parsedUrl.query), this.customParameters), {}, {
                    token: this.apiKey
                  }),
                  signal: e
                });

              case 4:
                _yield$r2 = _context3.sent;
                t = _yield$r2.data;
                o = _yield$r2.ssl;
                o && (this.url = this.url.replace(/^http:/i, "https:")), this.sourceJSON = t, this.read(t, {
                  origin: "service",
                  url: this.parsedUrl
                });

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _fetchService(_x5) {
        return _fetchService2.apply(this, arguments);
      }

      return _fetchService;
    }()
  }]);

  return q;
}(S(E(P(M(j(v(O(I(p(L(b(w(i(x))))))))))))));

e([l({
  type: Boolean
})], q.prototype, "datesInUnknownTimezone", void 0), e([l()], q.prototype, "dpi", void 0), e([l()], q.prototype, "gdbVersion", void 0), e([l()], q.prototype, "imageFormat", void 0), e([u("imageFormat", ["supportedImageFormatTypes"])], q.prototype, "readImageFormat", null), e([l({
  json: {
    origins: {
      service: {
        read: {
          source: "maxImageHeight"
        }
      }
    }
  }
})], q.prototype, "imageMaxHeight", void 0), e([l({
  json: {
    origins: {
      service: {
        read: {
          source: "maxImageWidth"
        }
      }
    }
  }
})], q.prototype, "imageMaxWidth", void 0), e([l()], q.prototype, "imageTransparency", void 0), e([l({
  type: Boolean,
  json: {
    read: !1,
    write: {
      enabled: !0,
      overridePolicy: function overridePolicy() {
        return {
          enabled: !1
        };
      }
    }
  }
})], q.prototype, "isReference", void 0), e([l({
  json: {
    read: !1,
    write: !1
  }
})], q.prototype, "labelsVisible", void 0), e([l({
  type: ["ArcGISMapServiceLayer"]
})], q.prototype, "operationalLayerType", void 0), e([l({
  json: {
    read: !1,
    write: !1
  }
})], q.prototype, "popupEnabled", void 0), e([l()], q.prototype, "sourceJSON", void 0), e([l({
  json: {
    write: {
      ignoreOrigin: !0
    }
  }
})], q.prototype, "sublayers", void 0), e([d("sublayers", {
  layers: {
    type: [T]
  },
  visibleLayers: {
    type: [c]
  }
})], q.prototype, "writeSublayers", null), e([l({
  type: ["show", "hide", "hide-children"]
})], q.prototype, "listMode", void 0), e([l({
  json: {
    read: !1
  },
  readOnly: !0,
  value: "map-image"
})], q.prototype, "type", void 0), e([l(U)], q.prototype, "url", void 0), q = e([y("esri.layers.MapImageLayer")], q);
var A = q;
export { A as default };